export default __webpack_public_path__ + "media/Bitbucket_left.e860ad8731c0b2d7dd69b2f6a692bb4c.svg";